import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-info-consecutivo',
  templateUrl: './info-consecutivo.component.html',
  styleUrls: ['./info-consecutivo.component.scss']
})
export class InfoConsecutivoComponent implements OnInit {

  public csc;
  public Datos;
  public operador_despacho;
  public hora_despacho;
  public operador;
  public dia;
  public Hora_creacion;
  public prioridadPorSintoma_usuario_creador;
  public hora_PrioridadPorSintoma;
  public webMappingPersonaActualiza;
  public webMappingPersonaConfirma;
  public webMappingHoraConfirma;
  public webMappingCreated;
  public webMappingUpdated;
  public datosRevaloracion;

  constructor(private servicios: ServiciosService, @Inject(MAT_DIALOG_DATA) private datos) {
    this.csc = datos.csc;
   }

  ngOnInit() {
    this.servicios.infocsc(this.csc).subscribe((data)=>{
      this.Datos = data;
      this.operador_despacho = this.Datos[0].operador_despacho;
      this.hora_despacho = this.Datos[0].hora_despacho;
      this.operador = this.Datos[0].operador;
      this.Hora_creacion = this.Datos[0].Hora_creacion;
      this.dia = this.Datos[0].REQDIA;
      this.prioridadPorSintoma_usuario_creador = this.Datos[0].prioridadPorSintoma_usuario_creador;
      this.hora_PrioridadPorSintoma = this.Datos[0].hora_PrioridadPorSintoma;
      this.webMappingPersonaActualiza = this.Datos[0].webMappingPersonaActualiza;
      this.webMappingPersonaConfirma = this.Datos[0].webMappingPersonaConfirma;
      this.webMappingHoraConfirma = this.Datos[0].webMappingHoraConfirma;
      this.webMappingCreated = this.Datos[0].webMappingCreated;
      this.webMappingUpdated = this.Datos[0].webMappingUpdated;
      this.datosRevaloracion = this.Datos[0].REQCDAData;
    });
  }
}
